export enum AppSource {
    ADMIN = "admin", // Admin web app
    WEB = "web", // Flutter web app
    MOBILE = "mobile", // Flutter mobile app
}
